import { Scene } from "@babylonjs/core/scene";
import { ArcRotateCamera } from "@babylonjs/core/Cameras/arcRotateCamera";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { HemisphericLight } from "@babylonjs/core/Lights/hemisphericLight";
import { SceneLoader } from "@babylonjs/core/Loading/sceneLoader";
import { CubeTexture } from "@babylonjs/core/Materials/Textures/cubeTexture";
// required imports
import "@babylonjs/core/Loading/loadingScreen";
import "@babylonjs/loaders/glTF";
import "@babylonjs/core/Materials/standardMaterial";
import "@babylonjs/core/Materials/Textures/Loaders/envTextureLoader";
import "@babylonjs/core/Animations/animatable";
// digital assets
import sceneGLB from "../../assets/glb/bon2.glb";
// import skyEnvironment from "../../assets/environment/sky.env"
import { ActionManager, Color3, ExecuteCodeAction, StandardMaterial, Animation, MeshBuilder, Color4, Texture, DynamicTexture } from "@babylonjs/core";
import { setupToolbox } from "../scene/toolbox";
import { HideLoadingUI, showLoadingUI } from "../scene/CustomLoadingScreen";
import { changeCamera } from "../lib/cameras/cameraChange";
import { setupUiContainer } from "../scene/UiContainer";
import skyEnvironment from "../../assets/environment/environment.env";
import paste from "../../assets/images/tooth-paste.png";
import spray from "../../assets/images/hand-gel.png";
//INIT LOADING LAYER 
showLoadingUI();
HideLoadingUI();
export class AppModeController {
    constructor() {
        this._createScene = async (engine, canvas) => {
            engine.displayLoadingUI();
            const scene = new Scene(engine);
            void Promise.all([
                import("@babylonjs/core/Debug/debugLayer"),
                import("@babylonjs/inspector"),
            ]).then((_values) => {
                console.log(_values);
                window.addEventListener("keydown", (e) => {
                    if (e.key === 'q') {
                        if (scene.debugLayer.isVisible()) {
                            scene.debugLayer.hide();
                        }
                        else {
                            scene.debugLayer.show({
                                handleResize: true,
                                overlay: true,
                                globalRoot: document.getElementById("#root") || undefined,
                            });
                        }
                    }
                });
                setupToolbox(scene);
            });
            setupUiContainer(scene);
            ///////////////////////
            // INITIAL VARIABLES //
            ///////////////////////
            var backButton = document.getElementById("backButton");
            var logo = document.getElementById("logo");
            var installationBTN = document.getElementById("installationBTN");
            var installationBTN2 = document.getElementById("installation2BTN");
            var actionButton = document.getElementById("dropdown");
            var nextRowButton = document.getElementById("nextPin");
            var nextRowButton2 = document.getElementById("nextPin2");
            const tableDiv = document.getElementById("tableDiv");
            const closeBtn = document.getElementById("closeBtn");
            const aceBtn = document.getElementById("ace");
            const vehicleBtn = document.getElementById("vehicleCon");
            const ledsBtn = document.getElementById("leds");
            const batteryBtn = document.getElementById("batteryConn");
            const espansionBtn = document.getElementById("espansionConn");
            ////////////
            // CAMERA //
            ////////////
            const mainCamera = new ArcRotateCamera("mainCamera", 2.425, 0.7, 0.2733, isMobile() ? new Vector3(0, -0.018, 0) : new Vector3(0, 0, 0), scene);
            mainCamera.minZ = 0.01;
            mainCamera.maxZ = 100000;
            mainCamera.lowerBetaLimit = 0.05;
            mainCamera.upperBetaLimit = 1.6;
            mainCamera.lowerRadiusLimit = 0.07;
            mainCamera.upperRadiusLimit = 1;
            // mainCamera.wheelPrecision= 0.0628;
            mainCamera.pinchDeltaPercentage = 0.003;
            mainCamera.wheelDeltaPercentage = 0.01;
            const pointerInput = mainCamera.inputs.attached.pointers;
            if (isMobile()) {
                mainCamera.fov = 1.2;
                pointerInput.panningSensibility = 0;
                mainCamera.useNaturalPinchZoom = true;
                console.log(mainCamera.fov, mainCamera.useNaturalPinchZoom);
            }
            else {
                mainCamera.fov = 0.8;
                pointerInput.buttons = [0];
            }
            mainCamera.speed = 0.0528;
            console.log(mainCamera.lowerAlphaLimit, mainCamera.upperAlphaLimit);
            mainCamera.attachControl(canvas, true);
            // mainCamera.useFramingBehavior = true;
            /// POINTS FOR CAMERA CHANGE ANIM FUNCTION 
            let zeroPoint = isMobile() ? { alpha: 28.2894, beta: 0.4, radius: 0.3, x: 0, y: -.015, z: 0 } : { alpha: 28.2894, beta: 0.4, radius: 0.3, x: 0, y: 0, z: 0 };
            let zeroPoint2 = isMobile() ? { alpha: 0.0176, beta: 0.4, radius: 0.4, x: 0.2, y: -.015, z: 0 } : { alpha: 0, beta: 0.4, radius: 0.6, x: 0, y: 0, z: 0 };
            let zeroPoint3 = isMobile() ? { alpha: 0.0176, beta: 0.4, radius: 0.4, x: 0.05, y: -.015, z: 0 } : { alpha: 0.0176, beta: 0.4, radius: 0.3, x: 0, y: 0, z: 0 };
            let installationPoint = { alpha: 0, beta: 0, radius: 0.44, x: 0, y: 0.00, z: 0 };
            let _AC_EPoint = isMobile() ? { alpha: 0.427, beta: 0.829, radius: 0.3, x: 0, y: -0.02, z: 0 } : { alpha: 0.427, beta: 0.829, radius: 0.3, x: 0, y: 0.05, z: 0 };
            let _EspansionConnPoint = { alpha: 3.8925, beta: 0.4, radius: 0.4, x: 0, y: 0.05, z: 0 };
            let _VehicleConnPoint = isMobile() ? { alpha: 28.2894, beta: 0.4, radius: 0.3, x: 0, y: -0.01, z: 0 } : { alpha: 28.2894, beta: 0.4, radius: 0.3, x: 0, y: 0.05, z: 0 };
            let _VehicleConnPoint2 = isMobile()
                ? { alpha: 28.2894, beta: 0.0, radius: 0.2, x: -0.035, y: -0.03, z: 0.0025 }
                : { alpha: 28.2894, beta: 0.1, radius: 0.1444, x: -0.017, y: 0, z: 0 }; // Default values for non-mobile
            let _BatteryConnPoint = isMobile() ? { alpha: -2.5, beta: 0.925, radius: 0.3, x: 0, y: -0.02, z: 0 } : { alpha: -2.5, beta: 0.925, radius: 0.3, x: 0, y: 0.05, z: 0 };
            let _espansionConPoint2 = isMobile() ? { alpha: 1.58, beta: 0.1, radius: 0.09, x: 0.022, y: 0.015, z: -.015 } : { alpha: 1.58, beta: 0.1, radius: 0.10, x: 0.0205, y: 0.00, z: -.017 };
            let _LedsPoint = { alpha: 1.918, beta: 0.846, radius: 0.2486, x: 0, y: 0.05, z: 0 };
            let _LedsPoint2 = isMobile() ? { alpha: 2.5959, beta: 0.5843, radius: 0.07, x: -0.01, y: 0.016, z: 0.043 } : { alpha: 8.8014, beta: 0.5313, radius: 0.0842, x: -0.012, y: 0.033, z: 0.046 };
            // // load the environment file
            scene.environmentTexture = new CubeTexture(skyEnvironment, scene);
            scene.environmentIntensity = .75;
            scene.clearColor = new Color4(0.887, 0.933, 0.941, 1);
            // // if not setting the envtext of the scene, we have to load the DDS module as well
            // new EnvironmentHelper({
            //     skyboxSize: 100,
            //     skyboxTexture: skyEnvironment,
            //     createGround: false,
            // }, scene);
            // This creates a light, aiming 0,1,0 - to the sky (non-mesh)
            const light = new HemisphericLight("light", new Vector3(0, 1, 0), scene);
            // // Default intensity is 1. Let's dim the light a small amount
            light.intensity = .5;
            const importResult = await SceneLoader.ImportMeshAsync("", "", sceneGLB, scene, undefined, ".glb");
            // just scale it so we can see it better
            for (let i = 0; i < importResult.meshes.length; i++) {
                importResult.meshes[i].scaling.scaleInPlace(1);
            }
            ////////////////////////////
            ////SETUP INIT ELEMENTS ////
            ///////////////////////////
            // let box = MeshBuilder.CreateBox("box",{},scene)
            // box.position.y = 3
            logo.classList.remove("is-hidden");
            installationBTN.classList.remove("is-hidden");
            // actionButton.classList.remove("is-hidden");
            // Define the materials
            let activeRowMaterial = new StandardMaterial("activeRowMaterial", scene);
            activeRowMaterial.diffuseColor = new Color3(0.2, 0.62, 0.8);
            activeRowMaterial.emissiveColor = new Color3(0.2, 0.62, 0.8);
            activeRowMaterial.alpha = 0.5;
            let normalPinMat = scene.getMaterialByName("gold");
            let greenLEDMat = new StandardMaterial("activeLEDMaterial", scene);
            greenLEDMat.diffuseColor = new Color3(0, 1, 0);
            greenLEDMat.emissiveColor = new Color3(0, 1, 0);
            let normalLEDMat = scene.getMaterialByName("led");
            let ledOne = scene.getMeshByName("leds.001");
            let ledTwo = scene.getMeshByName("leds.002");
            let ledThree = scene.getMeshByName("leds.003");
            let ledFour = scene.getMeshByName("leds.004");
            let ledsArray = [ledOne, ledTwo, ledThree, ledFour];
            scene.getTransformNodeByName("a").setEnabled(false);
            let screwsNode = scene.getTransformNodeByName("b");
            screwsNode.position = new Vector3(0, 0, -3);
            let screwOne = scene.getMeshByName("screw_b_01");
            let screwTwo = scene.getMeshByName("screw_b_02");
            let screwThree = scene.getMeshByName("screw_b_03");
            let screwOnePos = screwOne.position;
            let screwTwoPos = screwTwo.position;
            let screwThreePos = screwThree.position;
            let screwOnePosAfter = new Vector3(0.165, -7.725, -0.564);
            let screwTwoPosAfter = new Vector3(-6.815, 7.224, -0.564);
            let screwThreePosAfter = new Vector3(6.587, 7.224, -0.564);
            screwOne.rotationQuaternion = null;
            screwTwo.rotationQuaternion = null;
            screwThree.rotationQuaternion = null;
            screwOne.rotation = new Vector3(-0.5236, 0.8727, 0);
            screwTwo.rotation = new Vector3(0.5236, 0.8727, 0);
            screwThree.rotation = new Vector3(0.5236, 0.8727, 0);
            screwOne.position = new Vector3(0.165, -7.725, -0.564);
            screwTwo.position = new Vector3(-6.815, 7.224, -0.564);
            screwThree.position = new Vector3(6.587, 7.224, -0.564);
            screwsNode.setEnabled(false);
            const metalPlate = scene.getMeshByName("metal_plate");
            const pasteMesh = scene.getMeshByName("paste");
            const pasteMeshMaterial = scene.getMaterialByName("paste");
            pasteMeshMaterial.emissiveColor = new Color3(1, 0, 0);
            const fabric = scene.getMeshByName("Fabric");
            const fabricPosition = fabric.position;
            metalPlate.scaling.y = 0.3;
            const metalPlatePositioStart = new Vector3(0, 0, 0.9);
            metalPlate.position = metalPlatePositioStart;
            let newMetalPlatePosition = new Vector3(0, 0, 0);
            pasteMesh.scaling.y = 6;
            metalPlate.isVisible = false;
            pasteMesh.isVisible = false;
            fabric.isVisible = false;
            let sprayMat = new StandardMaterial("sprayMat", scene);
            let pasteMat = new StandardMaterial("pasteMat", scene);
            let mattArray = [sprayMat, pasteMat];
            const sprayDisc = MeshBuilder.CreateDisc("sprayDisc", { radius: .025 });
            sprayDisc.position = new Vector3(0, 0.025, 0);
            sprayMat.diffuseTexture = new Texture(spray, scene, false, false);
            sprayMat.diffuseTexture.hasAlpha = true;
            sprayDisc.material = sprayMat;
            const pasteDisc = MeshBuilder.CreateDisc("pasteDisc", { radius: .025 });
            pasteDisc.position = new Vector3(0, 0.025, 0);
            pasteMat.diffuseTexture = new Texture(paste, scene, false, false);
            pasteMat.diffuseTexture.hasAlpha = true;
            pasteMat.diffuseTexture.scale(0.5);
            pasteDisc.material = pasteMat;
            for (const mat of mattArray) {
                mat.diffuseColor = new Color3(1, 1, 1);
                mat.specularColor.copyFromFloats(0, 0, 0);
                // mat.disableLighting = true;
                mat.useAlphaFromDiffuseTexture = true;
            }
            sprayDisc.billboardMode = 7;
            pasteDisc.billboardMode = 7;
            sprayDisc.isVisible = false;
            pasteDisc.isVisible = false;
            const blinkIntervals = new Map(); // Correctly stores interval IDs
            function blinkDisc(disc, duration, interval = 300) {
                let elapsedTime = 0;
                let isVisible = true;
                // If already blinking, clear the previous interval
                if (blinkIntervals.has(disc)) {
                    clearInterval(blinkIntervals.get(disc));
                    blinkIntervals.delete(disc);
                }
                const blinkInterval = setInterval(() => {
                    isVisible = !isVisible;
                    disc.isVisible = isVisible;
                    elapsedTime += interval;
                    if (elapsedTime >= duration) {
                        clearInterval(blinkInterval);
                        blinkIntervals.delete(disc);
                        disc.isVisible = false; // Hide after blinking
                    }
                }, interval);
                blinkIntervals.set(disc, blinkInterval); // Store the interval ID
            }
            // Function to stop blinking immediately
            function stopBlink(disc) {
                if (blinkIntervals.has(disc)) {
                    clearInterval(blinkIntervals.get(disc));
                    blinkIntervals.delete(disc);
                    disc.isVisible = false; // Ensure it stays hidden
                }
            }
            // Run on every frame
            scene.onAfterRenderObservable.add(() => {
                engine.hideLoadingUI();
                // updateAnnotationPositions();
            });
            ////////////////////////////
            //ACTION MANAGER PROTOTYPE //
            /////////////////////////////
            var dragged = false;
            //Detects mouse up
            canvas.addEventListener("pointerup", function () {
                console.log("Mouse UP!");
                dragged = false;
            });
            //Detects mouse down
            canvas.addEventListener("pointerdown", function () {
                console.log("Mouse DOWN!");
                dragged = true;
            });
            //Detects click
            canvas.addEventListener("click", function () {
                console.log("Mouse Click!");
            });
            const setVisible = (value) => {
                let htmlIndicatorsDiv = document.getElementById("indicators");
                if (value === true) {
                    htmlIndicatorsDiv.classList.remove("is-hidden");
                }
                if (value === false) {
                    htmlIndicatorsDiv.classList.add("is-hidden");
                }
            };
            document.querySelectorAll('input[type="radio"]').forEach(radio => {
                radio.addEventListener('change', function () {
                    let group = this.closest('.led-group');
                    if (!group)
                        return;
                    let tooltip = group.querySelector('.tooltip');
                    if (!tooltip)
                        return;
                    // Get tooltip text from the data-tooltip attribute
                    let message = this.getAttribute('data-tooltip') || 'Select a status';
                    tooltip.textContent = message;
                    // Remove active class from other buttons in the group
                    group.querySelectorAll('.color-indicator').forEach(indicator => {
                        indicator.classList.remove('active');
                    });
                    // Add active class to the selected button's indicator
                    let indicator = this.nextElementSibling;
                    if (indicator) {
                        indicator.classList.add('active');
                    }
                });
            });
            // Helper function to create animations
            function createAnimation(target, property, fromValue, toValue, speed, duration, onEndCallback) {
                const anim = Animation.CreateAndStartAnimation("anim", target, property, speed, duration, fromValue, toValue, Animation.ANIMATIONLOOPMODE_CONSTANT, null, () => {
                    anim.disposeOnEnd = true; // Dispose of the animation after it completes
                    if (onEndCallback)
                        onEndCallback();
                });
                anim.disposeOnEnd = true; // Ensure cleanup even if onEndCallback isn't provided
                return anim;
            }
            // Function to animate screws' position
            function animateScrewPosition(screw, fromPosition, toPosition, speed, duration, onEndCallback) {
                createAnimation(screw, "position", fromPosition, toPosition, speed, duration, onEndCallback);
            }
            // Function to animate screws' rotation
            function animateScrewRotation(screw, fromRotation, toRotation, speed, duration, onEndCallback) {
                createAnimation(screw, "rotation", fromRotation, toRotation, speed, duration, onEndCallback);
            }
            function screwsResetAfterAnim() {
                screwsNode.setEnabled(false);
                screwOne.rotation = new Vector3(-0.5236, 0.8727, 0);
                screwTwo.rotation = new Vector3(0.5236, 0.8727, 0);
                screwThree.rotation = new Vector3(0.5236, 0.8727, 0);
                screwOne.position = new Vector3(0.165, -7.725, -0.564);
                screwTwo.position = new Vector3(-6.815, 7.224, -0.564);
                screwThree.position = new Vector3(6.587, 7.224, -0.564);
                screwsNode.position = new Vector3(0, 0, -3);
            }
            // Function to show an annotation and wait for it to be closed before proceeding
            const showAnnotation = (annotationId, callback) => {
                const annotation = document.getElementById(annotationId);
                if (annotation) {
                    annotation.classList.remove("is-hidden"); // Show annotation
                    const closeButton = annotation.querySelector(".arrow"); // Find the arrow button
                    if (closeButton) {
                        const closeHandler = () => {
                            annotation.classList.add("is-hidden"); // Hide annotation
                            closeButton.removeEventListener("click", closeHandler); // Remove event listener to avoid duplicates
                            if (callback)
                                callback(); // Continue animation
                        };
                        closeButton.addEventListener("click", closeHandler); // Wait for user to close
                    }
                }
                else {
                    if (callback)
                        callback(); // If annotation doesn't exist, proceed immediately
                }
            };
            const hideAnnotation = (annotationId, callback) => {
                const annotation = document.getElementById(annotationId);
                if (annotation) {
                    annotation.classList.add("is-hidden"); // Hide annotation
                    if (callback)
                        callback(); // Execute callback if provided
                }
                else {
                    if (callback)
                        callback(); // Proceed even if annotation doesn't exist
                }
            };
            // Main installation button logic
            installationBTN.onclick = () => {
                changeCamera(mainCamera, scene, zeroPoint2, 100, null);
                disableHighlights();
                // Reset all materials and set isPickable/isClickable to false
                Object.values(groups).flat().forEach(meshName => {
                    const mesh = scene.getMeshByName(meshName);
                    if (mesh) {
                        mesh.material = normalMaterial;
                        mesh.isPickable = false;
                    }
                    scene.getMeshByName("v_e_con").material = blackMaterial;
                    scene.getMeshByName("v_e_con_back").material = blackMaterial;
                    ledOne.material = ledMaterial;
                    ledTwo.material = ledMaterial;
                    ledThree.material = ledMaterial;
                    ledFour.material = ledMaterial;
                });
                installationBTN.classList.add("is-hidden");
                setVisible(false);
                root.setEnabled(false);
                // Start root animation
                function moveRootToNewPosition(callback) {
                    animatePosition(root, rootPositionStart, newRootPosition, 60, 100, () => {
                        if (isMobile()) {
                            mainCamera.target = new Vector3(0.15, 0, 0);
                        }
                        metalPlate.isVisible = true;
                        backButton.classList.remove("is-hidden");
                        backButton.onclick = handleBackButton;
                        callback();
                    });
                }
                function moveMetalPlate(callback) {
                    backButton.classList.add("is-hidden");
                    animatePosition(metalPlate, metalPlatePositioStart, newMetalPlatePosition, 50, 100, () => {
                        root.position = metalPlatePositioStart;
                        backButton.classList.remove("is-hidden");
                        backButton.onclick = handleBackButton;
                        callback();
                    });
                }
                function showMountingAnnotation(callback) {
                    backButton.classList.add("is-hidden");
                    showAnnotation("Mounting", callback);
                    backButton.classList.remove("is-hidden");
                    backButton.onclick = handleBackButton;
                }
                function showCleaningAnnotation(callback) {
                    backButton.classList.add("is-hidden");
                    fabric.isVisible = true;
                    showAnnotation("Cleaning", callback);
                    backButton.classList.remove("is-hidden");
                    backButton.onclick = handleBackButton;
                }
                function performFabricWiping(callback) {
                    backButton.classList.add("is-hidden");
                    const wipeStart = fabricPosition;
                    const wipeMid = new Vector3(fabricPosition.x + 0.1, fabricPosition.y, -0.3);
                    const wipeMidBack = new Vector3(fabricPosition.x - 0.1, fabricPosition.y, -0.3);
                    const wipeEnd = newRootPosition;
                    blinkDisc(sprayDisc, 3000);
                    animatePosition(fabric, wipeStart, wipeMid, 100, 100, () => {
                        animatePosition(fabric, wipeMid, wipeMidBack, 100, 100, () => {
                            animatePosition(fabric, wipeMidBack, wipeMid, 100, 100, () => {
                                animatePosition(fabric, wipeMid, wipeEnd, 100, 100, () => {
                                    pasteMesh.isVisible = true;
                                    root.setEnabled(true);
                                    root.position = metalPlatePositioStart;
                                    blinkDisc(pasteDisc, 6000);
                                    fabric.isVisible = false;
                                    backButton.classList.remove("is-hidden");
                                    backButton.onclick = handleBackButton;
                                    callback();
                                });
                            });
                        });
                    });
                }
                function showThermalPasteAnnotation(callback) {
                    backButton.classList.add("is-hidden");
                    showAnnotation("ThermalPaste", callback);
                    backButton.classList.remove("is-hidden");
                }
                function reverseRootAnimation(callback) {
                    backButton.classList.add("is-hidden");
                    animatePosition(root, metalPlatePositioStart, rootPositionStart, 60, 100, () => {
                        pasteMesh.isVisible = false;
                        screwsNode.setEnabled(true);
                        backButton.classList.remove("is-hidden");
                        backButton.onclick = handleBackButton;
                        callback();
                    });
                }
                function showScrewsAnnotationAndReverse() {
                    showAnnotation("Screws", () => {
                        handleInstallationReverse();
                    });
                }
                // ** Main Function to Start Step-by-Step Process**
                function startInstallationProcess() {
                    moveRootToNewPosition(() => {
                        moveMetalPlate(() => {
                            showMountingAnnotation(() => {
                                showCleaningAnnotation(() => {
                                    performFabricWiping(() => {
                                        showThermalPasteAnnotation(() => {
                                            reverseRootAnimation(() => {
                                                showScrewsAnnotationAndReverse();
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                }
                startInstallationProcess();
            };
            const screwStartRotations = [
                new Vector3(-0.5236, 0.8727, 0),
                new Vector3(0.5236, 0.8727, 0),
                new Vector3(0.5236, 0.8727, 0),
            ];
            const screwPos = [
                screwOnePos,
                screwTwoPos,
                screwThreePos
            ];
            const screwPosAfter = [
                new Vector3(0.165, -7.725, -0.564),
                new Vector3(-6.815, 7.224, -0.564),
                new Vector3(6.587, 7.224, -0.564),
            ];
            // Helper function to animate screw rotation and position
            const animateScrew = (screw, startRotation, endRotation, startPos, endPos, index, callback) => {
                animateScrewRotation(screw, startRotation, endRotation, 200, 100, null);
                animateScrewPosition(screw, endPos, startPos, 150, 100, () => {
                    if (index === 2 && callback) {
                        callback();
                    }
                });
            };
            function handleInstallationReverse() {
                if (isMobile()) {
                    changeCamera(mainCamera, scene, zeroPoint3, 100, null);
                }
                // Animate each screw's rotation and position
                [screwOne, screwTwo, screwThree].forEach((screw, index) => {
                    animateScrew(screw, screwStartRotations[index], new Vector3(0, 0, 0), screwPos[index], screwPosAfter[index], index, () => {
                        if (index === 2) {
                            // Animate screws node position back
                            animateScrewPosition(screwsNode, new Vector3(0, 0, -3), new Vector3(0, 0, 0), 150, 100, () => {
                                screwsPlane.isVisible = false;
                                showHideDimensions(true, false);
                                dimensionsPlanesArray.forEach(mesh => (mesh.isVisible = true));
                                backButton.classList.remove("is-hidden");
                            });
                        }
                    });
                });
                backButton.onclick = handleBackButton;
            }
            // Handle back button logic
            function handleBackButton() {
                root.position = rootPositionStart;
                stopBlink(sprayDisc);
                stopBlink(pasteDisc);
                root.setEnabled(true);
                screwsResetAfterAnim();
                changeCamera(mainCamera, scene, zeroPoint, 100, () => {
                    enableHighlights();
                });
                hideAnnotation("Mounting");
                hideAnnotation("Cleaning");
                hideAnnotation("ThermalPaste");
                hideAnnotation("Screws");
                backButton.classList.add("is-hidden");
                installationBTN.classList.remove("is-hidden");
                setVisible(true);
                showHideDimensions(false, false);
                fabric.isVisible = false;
                pasteMesh.isVisible = false;
                metalPlate.isVisible = false;
                fabric.position = fabricPosition;
                dimensionsPlanesArray.forEach(mesh => (mesh.isVisible = false));
                backButton.onclick = null;
            }
            // Helper function to animate position
            function animatePosition(mesh, startPos, endPos, speed, frames, callback) {
                return Animation.CreateAndStartAnimation(`${mesh.name}Anim`, mesh, "position", speed, frames, startPos, endPos, Animation.ANIMATIONLOOPMODE_CONSTANT, null, () => {
                    callback?.();
                });
            }
            const ledsInfo = document.getElementById("ledsInfo");
            const root = scene.getTransformNodeByName("XLV_A1");
            const rootChildren = root.getChildMeshes();
            let rootPositionStart = root.position;
            let newRootPosition = new Vector3(0, 0, -.7);
            console.log(rootChildren);
            //html buttons  ACTIONS MANAGER
            scene.getMeshByName("connections.003").actionManager = new ActionManager(scene);
            const acAnnotation = document.getElementById("AC");
            scene.getMeshByName("connections.003").actionManager.registerAction(new ExecuteCodeAction(ActionManager.OnPickTrigger, () => {
                // Piwik PRO analytics tag
                // @ts-ignore
                _paq.push(["trackEvent", 'Dummy indic clicked', 'Main']);
                const normalMeshes = ["connections.003", "connections.004", "connections.005"];
                // Iterate over each mesh in rootChildren
                rootChildren.forEach((mesh) => {
                    if (normalMeshes.includes(mesh.name)) {
                        // Keep these meshes normal (default visibility)
                        mesh.visibility = 1; // Normal visibility
                    }
                    else {
                        // Set visibility to 0.3 for other meshes
                        mesh.visibility = 0.1;
                    }
                });
                acAnnotation.classList.remove("is-hidden");
                // annotations["AC"].annotation.classList.remove("is-hidden");
                setVisible(false);
                changeCamera(mainCamera, scene, _AC_EPoint, 100, null);
                disableHighlights();
                backButton.classList.remove("is-hidden");
                backButton.onclick = () => {
                    acAnnotation.classList.add("is-hidden");
                    backButton.classList.add("is-hidden");
                    setVisible(true);
                    enableHighlights();
                    changeCamera(mainCamera, scene, zeroPoint, 100, null);
                    rootChildren.forEach((mesh) => {
                        mesh.visibility = 1;
                    });
                    backButton.onclick = null;
                };
                // dummyIndicText.textPlane.visibility = 0
            }));
            scene.getMeshByName("connections.004").actionManager = new ActionManager(scene);
            scene.getMeshByName("connections.004").actionManager.registerAction(new ExecuteCodeAction(ActionManager.OnPickTrigger, () => {
                // Piwik PRO analytics tag
                // @ts-ignore
                _paq.push(["trackEvent", 'Dummy indic clicked', 'Main']);
                const normalMeshes = ["connections.003", "connections.004", "connections.005"];
                // Iterate over each mesh in rootChildren
                rootChildren.forEach((mesh) => {
                    if (normalMeshes.includes(mesh.name)) {
                        // Keep these meshes normal (default visibility)
                        mesh.visibility = 1; // Normal visibility
                    }
                    else {
                        // Set visibility to 0.3 for other meshes
                        mesh.visibility = 0.1;
                    }
                });
                acAnnotation.classList.remove("is-hidden");
                setVisible(false);
                disableHighlights();
                changeCamera(mainCamera, scene, _AC_EPoint, 100, null);
                backButton.classList.remove("is-hidden");
                backButton.onclick = () => {
                    acAnnotation.classList.add("is-hidden");
                    backButton.classList.add("is-hidden");
                    setVisible(true);
                    enableHighlights();
                    changeCamera(mainCamera, scene, zeroPoint, 100, null);
                    rootChildren.forEach((mesh) => {
                        mesh.visibility = 1;
                    });
                    backButton.onclick = null;
                };
                // dummyIndicText.textPlane.visibility = 0
            }));
            scene.getMeshByName("connections.005").actionManager = new ActionManager(scene);
            scene.getMeshByName("connections.005").actionManager.registerAction(new ExecuteCodeAction(ActionManager.OnPickTrigger, () => {
                // Piwik PRO analytics tag
                // @ts-ignore
                _paq.push(["trackEvent", 'Dummy indic clicked', 'Main']);
                const normalMeshes = ["connections.003", "connections.004", "connections.005"];
                // Iterate over each mesh in rootChildren
                rootChildren.forEach((mesh) => {
                    if (normalMeshes.includes(mesh.name)) {
                        // Keep these meshes normal (default visibility)
                        mesh.visibility = 1; // Normal visibility
                    }
                    else {
                        // Set visibility to 0.3 for other meshes
                        mesh.visibility = 0.1;
                    }
                });
                acAnnotation.classList.remove("is-hidden");
                setVisible(false);
                changeCamera(mainCamera, scene, _AC_EPoint, 100, null);
                disableHighlights();
                backButton.classList.remove("is-hidden");
                backButton.onclick = () => {
                    acAnnotation.classList.add("is-hidden");
                    backButton.classList.add("is-hidden");
                    setVisible(true);
                    enableHighlights();
                    changeCamera(mainCamera, scene, zeroPoint, 100, null);
                    rootChildren.forEach((mesh) => {
                        mesh.visibility = 1;
                    });
                    backButton.onclick = null;
                };
                // dummyIndicText.textPlane.visibility = 0
            }));
            aceBtn.onclick = () => {
                // Piwik PRO analytics tag
                // @ts-ignore
                _paq.push(["trackEvent", 'Dummy indic clicked', 'Main']);
                // annotations["AC"].annotation.classList.remove("is-hidden");
                const normalMeshes = ["connections.003", "connections.004", "connections.005"];
                // Iterate over each mesh in rootChildren
                rootChildren.forEach((mesh) => {
                    if (normalMeshes.includes(mesh.name)) {
                        // Keep these meshes normal (default visibility)
                        mesh.visibility = 1; // Normal visibility
                    }
                    else {
                        // Set visibility to 0.3 for other meshes
                        mesh.visibility = 0.1;
                    }
                });
                acAnnotation.classList.remove("is-hidden");
                setVisible(false);
                changeCamera(mainCamera, scene, _AC_EPoint, 100, null);
                disableHighlights();
                backButton.classList.remove("is-hidden");
                backButton.onclick = () => {
                    acAnnotation.classList.add("is-hidden");
                    backButton.classList.add("is-hidden");
                    setVisible(true);
                    enableHighlights();
                    changeCamera(mainCamera, scene, zeroPoint, 100, null);
                    rootChildren.forEach((mesh) => {
                        mesh.visibility = 1;
                    });
                    backButton.onclick = null;
                };
                // dummyIndicText.textPlane.visibility = 0
            };
            scene.getMeshByName("espansion__con").actionManager = new ActionManager(scene);
            scene.getMeshByName("espansion__con").actionManager.registerAction(new ExecuteCodeAction(ActionManager.OnPickTrigger, () => {
                // Piwik PRO analytics tag
                // @ts-ignore
                _paq.push(["trackEvent", 'anotherDummy indic clicked', 'Main']);
                // annotations["EspansionConn"].annotation.classList.remove("is-hidden");
                console.log("clicked");
                setVisible(false);
                // changeCamera(mainCamera, scene, _EspansionConnPoint, 100, null);
                disableHighlights();
                // anotherDummyIndicText.textPlane.visibility = 0
                setVisible(false);
                mainCamera.lowerRadiusLimit = 0.07;
                mainCamera.minZ = 0.01;
                changeCamera(mainCamera, scene, _espansionConPoint2, 100, null);
                installationBTN.classList.add("is-hidden");
                const normalMeshes = ["espansion__con", "espansion__con.001", "espansion__con.002", "espansion__con.003", "espansion__con.004",
                    "espansion__con.005", "espansion__con.006", "espansion__con.007", "espansion__con.008", "espansion__con.009", "espansion__con.010",
                    "espansion__con.011", "espansion__con.012"
                ];
                // Iterate over each mesh in rootChildren
                light.intensity = 0.2;
                rootChildren.forEach((mesh) => {
                    if (normalMeshes.includes(mesh.name)) {
                        // Keep these meshes normal (default visibility)
                        mesh.visibility = 1; // Normal visibility
                    }
                    else {
                        // Set visibility to 0.3 for other meshes
                        mesh.visibility = 0.1;
                    }
                });
                pinData2.forEach((pin, index) => {
                    const mesh = scene.getMeshByName(pin.name);
                    if (mesh) {
                        mesh.isPickable = true;
                    }
                });
                setTimeout(() => {
                    backButton.classList.remove("is-hidden");
                    menuContainerSmall.classList.remove("is-hidden");
                }, 1000);
                setTimeout(() => {
                    mainCamera.maxZ = 100000;
                    mainCamera.lowerAlphaLimit = 1.58;
                    mainCamera.upperAlphaLimit = 1.58;
                    mainCamera.lowerBetaLimit = 0.1;
                    mainCamera.upperBetaLimit = 0.1;
                    mainCamera.upperRadiusLimit = 0.4;
                    // mainCamera.wheelPrecision= 0.0628;
                    mainCamera.pinchDeltaPercentage = 0.003;
                    mainCamera.wheelDeltaPercentage = 0.01;
                    mainCamera.speed = 0.0628;
                }, 2000);
                // highlightPin(currentPinIndex);
                backButton.onclick = () => {
                    enableHighlights();
                    menuContainerSmall.classList.add("is-hidden");
                    rootChildren.forEach((mesh) => {
                        mesh.visibility = 1;
                    });
                    pinData2.forEach((pin, index) => {
                        const mesh = scene.getMeshByName(pin.name);
                        if (mesh) {
                            mesh.isPickable = false;
                        }
                    });
                    setTimeout(() => {
                        mainCamera.lowerRadiusLimit = 0.2;
                    }, 2000);
                    mainCamera.minZ = 0.01;
                    mainCamera.maxZ = 100000;
                    mainCamera.lowerBetaLimit = 0.1;
                    mainCamera.upperBetaLimit = 1.6;
                    mainCamera.lowerAlphaLimit = null;
                    mainCamera.upperAlphaLimit = null;
                    mainCamera.upperRadiusLimit = 1;
                    // mainCamera.wheelPrecision= 0.0628;
                    mainCamera.pinchDeltaPercentage = 0.003;
                    mainCamera.wheelDeltaPercentage = 0.01;
                    mainCamera.speed = 0.0628;
                    unHighlightPin();
                    highlightedPinIndex = null;
                    // currentPinIndex = 0;
                    setVisible(true);
                    changeCamera(mainCamera, scene, zeroPoint, 100, null);
                    installationBTN.classList.remove("is-hidden");
                    // actionButton.classList.remove("is-hidden");
                    backButton.classList.add("is-hidden");
                    nextRowButton2.classList.add("is-hidden");
                    light.intensity = .5;
                    backButton.onclick = null;
                };
            }));
            espansionBtn.onclick = () => {
                // Piwik PRO analytics tag
                // @ts-ignore
                _paq.push(["trackEvent", 'anotherDummy indic clicked', 'Main']);
                // annotations["EspansionConn"].annotation.classList.remove("is-hidden");
                console.log("clicked");
                setVisible(false);
                // changeCamera(mainCamera, scene, _EspansionConnPoint, 100, null);
                disableHighlights();
                setVisible(false);
                mainCamera.lowerRadiusLimit = 0.07;
                mainCamera.minZ = 0.01;
                changeCamera(mainCamera, scene, _espansionConPoint2, 100, null);
                installationBTN.classList.add("is-hidden");
                const normalMeshes = ["espansion__con", "espansion__con.001", "espansion__con.002", "espansion__con.003", "espansion__con.004",
                    "espansion__con.005", "espansion__con.006", "espansion__con.007", "espansion__con.008", "espansion__con.009", "espansion__con.010",
                    "espansion__con.011", "espansion__con.012"
                ];
                // Iterate over each mesh in rootChildren
                light.intensity = 0.2;
                rootChildren.forEach((mesh) => {
                    if (normalMeshes.includes(mesh.name)) {
                        // Keep these meshes normal (default visibility)
                        mesh.visibility = 1; // Normal visibility
                    }
                    else {
                        // Set visibility to 0.3 for other meshes
                        mesh.visibility = 0.1;
                    }
                });
                pinData2.forEach((pin, index) => {
                    const mesh = scene.getMeshByName(pin.name);
                    if (mesh) {
                        mesh.isPickable = true;
                    }
                });
                setTimeout(() => {
                    backButton.classList.remove("is-hidden");
                    menuContainerSmall.classList.remove("is-hidden");
                }, 1000);
                setTimeout(() => {
                    mainCamera.maxZ = 100000;
                    mainCamera.lowerAlphaLimit = 1.58;
                    mainCamera.upperAlphaLimit = 1.58;
                    mainCamera.lowerBetaLimit = 0.1;
                    mainCamera.upperBetaLimit = 0.1;
                    mainCamera.upperRadiusLimit = 0.4;
                    // mainCamera.wheelPrecision= 0.0628;
                    mainCamera.pinchDeltaPercentage = 0.003;
                    mainCamera.wheelDeltaPercentage = 0.01;
                    mainCamera.speed = 0.0628;
                }, 1100);
                // highlightPin(currentPinIndex);
                backButton.onclick = () => {
                    enableHighlights();
                    menuContainerSmall.classList.add("is-hidden");
                    rootChildren.forEach((mesh) => {
                        mesh.visibility = 1;
                    });
                    pinData2.forEach((pin, index) => {
                        const mesh = scene.getMeshByName(pin.name);
                        if (mesh) {
                            mesh.isPickable = false;
                        }
                    });
                    setTimeout(() => {
                        mainCamera.lowerRadiusLimit = 0.2;
                    }, 2000);
                    mainCamera.minZ = 0.01;
                    mainCamera.maxZ = 100000;
                    mainCamera.lowerBetaLimit = 0.1;
                    mainCamera.upperBetaLimit = 1.6;
                    mainCamera.lowerAlphaLimit = null;
                    mainCamera.upperAlphaLimit = null;
                    mainCamera.upperRadiusLimit = 1;
                    // mainCamera.wheelPrecision= 0.0628;
                    mainCamera.pinchDeltaPercentage = 0.003;
                    mainCamera.wheelDeltaPercentage = 0.01;
                    mainCamera.speed = 0.0628;
                    unHighlightPin();
                    highlightedPinIndex = null;
                    // currentPinIndex = 0;
                    setVisible(true);
                    changeCamera(mainCamera, scene, zeroPoint, 100, null);
                    installationBTN.classList.remove("is-hidden");
                    // actionButton.classList.remove("is-hidden");
                    backButton.classList.add("is-hidden");
                    nextRowButton2.classList.add("is-hidden");
                    light.intensity = .5;
                    backButton.onclick = null;
                };
                // anotherDummyIndicText.textPlane.visibility = 0
            };
            let ledMode;
            function setLEDMode(mode) {
                ledMode = mode;
                console.log(`LED Mode switched to: ${ledMode}`);
            }
            const ledClickStart = () => {
                if (ledMode !== "detailed")
                    return; // Only run if in "detailed" mode
                // // Piwik PRO analytics tag
                // // @ts-ignore
                // _paq.push(["trackEvent", 'anotherDummy indic clicked', 'Main']);
                // annotations["Leds"].annotation.classList.remove("is-hidden");
                console.log("clicked");
                disableHighlights();
                setVisible(false);
                mainCamera.lowerRadiusLimit = 0.07;
                ledOne.material = greenLEDMat;
                ledTwo.material = greenLEDMat;
                ledThree.material = greenLEDMat;
                stopBlinking = toggleMaterial(ledFour, greenLEDMat, normalLEDMat, 500);
                setLEDMode('cycle');
                ledClickColor();
                // annotations["Leds"].annotation.classList.add("is-hidden");
                installationBTN.classList.add("is-hidden");
                // Uncheck all radio buttons
                document.querySelectorAll("input[type='radio']").forEach(radio => {
                    radio.checked = false;
                });
                const normalMeshes = ["leds.001", "leds.002", "leds.003", "leds.004"];
                // Iterate over each mesh in rootChildren
                rootChildren.forEach((mesh) => {
                    if (normalMeshes.includes(mesh.name)) {
                        // Keep these meshes normal (default visibility)
                        mesh.visibility = 1; // Normal visibility
                    }
                    else {
                        // Set visibility to 0.3 for other meshes
                        mesh.visibility = 0.1;
                    }
                });
                changeCamera(mainCamera, scene, _LedsPoint2, 100, () => {
                    tableDiv.classList.remove("is-hidden");
                    backButton.classList.remove("is-hidden");
                    ledOne.isPickable = true;
                    ledTwo.isPickable = true;
                    ledThree.isPickable = true;
                    ledFour.isPickable = true;
                });
                backButton.onclick = () => {
                    changeCamera(mainCamera, scene, zeroPoint, 100, null);
                    enableHighlights();
                    backButton.classList.add("is-hidden");
                    tableDiv.classList.add("is-hidden");
                    installationBTN.classList.remove("is-hidden");
                    setVisible(true);
                    stopBlinking();
                    ledOne.material = normalLEDMat;
                    ledTwo.material = normalLEDMat;
                    ledThree.material = normalLEDMat;
                    ledFour.material = normalLEDMat;
                    let buttons = document.querySelectorAll(`td button`);
                    buttons.forEach(btn => btn.classList.remove('active'));
                    setLEDMode('detailed');
                    ledStart();
                    rootChildren.forEach((mesh) => {
                        mesh.visibility = 1;
                    });
                    backButton.onclick = null;
                };
            };
            setLEDMode('detailed');
            const ledStart = () => {
                for (let i = 1; i <= 4; i++) {
                    const ledMesh = scene.getMeshByName(`leds.00${i}`);
                    if (ledMesh) {
                        ledMesh.actionManager = new ActionManager(scene);
                        ledMesh.actionManager.registerAction(new ExecuteCodeAction(ActionManager.OnPickTrigger, () => {
                            ledClickStart();
                        }));
                    }
                }
            };
            ledStart();
            ledsBtn.onclick = () => {
                ledClickStart();
                // anotherDummyIndicText.textPlane.visibility = 0
            };
            const batteryAnnotation = document.getElementById("BatteryConn");
            scene.getMeshByName("connections.001").actionManager = new ActionManager(scene);
            scene.getMeshByName("connections.001").actionManager.registerAction(new ExecuteCodeAction(ActionManager.OnPickTrigger, () => {
                const normalMeshes = ["connections.001", "connections.002"];
                // Iterate over each mesh in rootChildren
                rootChildren.forEach((mesh) => {
                    if (normalMeshes.includes(mesh.name)) {
                        // Keep these meshes normal (default visibility)
                        mesh.visibility = 1; // Normal visibility
                    }
                    else {
                        // Set visibility to 0.3 for other meshes
                        mesh.visibility = 0.1;
                    }
                });
                // Piwik PRO analytics tag
                // @ts-ignore
                _paq.push(["trackEvent", 'anotherDummy indic clicked', 'Main']);
                batteryAnnotation.classList.remove("is-hidden");
                // annotations["BatteryConn"].annotation.classList.remove("is-hidden");
                console.log("clicked");
                setVisible(false);
                changeCamera(mainCamera, scene, _BatteryConnPoint, 100, null);
                disableHighlights();
                backButton.classList.remove("is-hidden");
                backButton.onclick = () => {
                    batteryAnnotation.classList.add("is-hidden");
                    backButton.classList.add("is-hidden");
                    setVisible(true);
                    enableHighlights();
                    changeCamera(mainCamera, scene, zeroPoint, 100, null);
                    rootChildren.forEach((mesh) => {
                        mesh.visibility = 1;
                    });
                    backButton.onclick = null;
                };
                // anotherDummyIndicText.textPlane.visibility = 0
            }));
            scene.getMeshByName("connections.002").actionManager = new ActionManager(scene);
            scene.getMeshByName("connections.002").actionManager.registerAction(new ExecuteCodeAction(ActionManager.OnPickTrigger, () => {
                const normalMeshes = ["connections.001", "connections.002"];
                // Iterate over each mesh in rootChildren
                rootChildren.forEach((mesh) => {
                    if (normalMeshes.includes(mesh.name)) {
                        // Keep these meshes normal (default visibility)
                        mesh.visibility = 1; // Normal visibility
                    }
                    else {
                        // Set visibility to 0.3 for other meshes
                        mesh.visibility = 0.1;
                    }
                });
                // Piwik PRO analytics tag
                // @ts-ignore
                _paq.push(["trackEvent", 'anotherDummy indic clicked', 'Main']);
                batteryAnnotation.classList.remove("is-hidden");
                // annotations["BatteryConn"].annotation.classList.remove("is-hidden");
                console.log("clicked");
                setVisible(false);
                changeCamera(mainCamera, scene, _BatteryConnPoint, 100, null);
                disableHighlights();
                backButton.classList.remove("is-hidden");
                backButton.onclick = () => {
                    batteryAnnotation.classList.add("is-hidden");
                    backButton.classList.add("is-hidden");
                    setVisible(true);
                    enableHighlights();
                    changeCamera(mainCamera, scene, zeroPoint, 100, null);
                    rootChildren.forEach((mesh) => {
                        mesh.visibility = 1;
                    });
                    backButton.onclick = null;
                };
                // anotherDummyIndicText.textPlane.visibility = 0
            }));
            batteryBtn.onclick = () => {
                // Piwik PRO analytics tag
                // @ts-ignore
                _paq.push(["trackEvent", 'anotherDummy indic clicked', 'Main']);
                batteryAnnotation.classList.remove("is-hidden");
                const normalMeshes = ["connections.001", "connections.002"];
                // Iterate over each mesh in rootChildren
                rootChildren.forEach((mesh) => {
                    if (normalMeshes.includes(mesh.name)) {
                        // Keep these meshes normal (default visibility)
                        mesh.visibility = 1; // Normal visibility
                    }
                    else {
                        // Set visibility to 0.3 for other meshes
                        mesh.visibility = 0.1;
                    }
                });
                // annotations["BatteryConn"].annotation.classList.remove("is-hidden");
                console.log("clicked");
                setVisible(false);
                changeCamera(mainCamera, scene, _BatteryConnPoint, 100, null);
                disableHighlights();
                backButton.classList.remove("is-hidden");
                backButton.onclick = () => {
                    batteryAnnotation.classList.add("is-hidden");
                    backButton.classList.add("is-hidden");
                    setVisible(true);
                    enableHighlights();
                    changeCamera(mainCamera, scene, zeroPoint, 100, null);
                    rootChildren.forEach((mesh) => {
                        mesh.visibility = 1;
                    });
                    backButton.onclick = null;
                };
                // anotherDummyIndicText.textPlane.visibility = 0
            };
            function activateFirstRow() {
                // 1. Set first row button to active
                document.querySelectorAll('.rowButton').forEach(btn => btn.classList.remove('activeBtn'));
                const firstRowButton = document.querySelector(`.rowButton[data-row="1"]`);
                if (firstRowButton) {
                    firstRowButton.classList.add('activeBtn');
                }
                // 2. Show first row pin list
                document.querySelectorAll('.pinList').forEach(el => {
                    el.style.display = el.id === "row1" ? 'flex' : 'none';
                });
                // 3. Reset all pins to normal material
                pinData.forEach(pin => {
                    const pinMesh = scene.getMeshByName(`v_e_con.${String(pin.pin).padStart(3, '0')}`);
                    if (pinMesh) {
                        pinMesh.material = normalMaterialBig;
                    }
                });
                // 4. Highlight first row pins
                pinData.filter(pin => pin.row === 1).forEach(pin => {
                    const pinMesh = scene.getMeshByName(`v_e_con.${String(pin.pin).padStart(3, '0')}`);
                    if (pinMesh) {
                        pinMesh.material = activeRowMaterial;
                    }
                });
                // 5. Remove active class from all pin spans (no pin is initially selected)
                document.querySelectorAll('.pinSpan').forEach(pinSpan => pinSpan.classList.remove('activeBtn'));
            }
            function goToBigPinMode() {
                // Piwik PRO analytics tag
                // @ts-ignore
                _paq.push(["trackEvent", 'anotherDummy indic clicked', 'Main']);
                // annotations["VehicleConn"].annotation.classList.remove("is-hidden");
                console.log("clicked");
                setVisible(false);
                disableHighlights();
                setVisible(false);
                mainCamera.lowerRadiusLimit = 0.12;
                mainCamera.minZ = 0.01;
                changeCamera(mainCamera, scene, _VehicleConnPoint2, 100, null);
                pinMenu.classList.remove("is-hidden");
                installationBTN.classList.add("is-hidden");
                for (let i = 1; i <= 35; i++) {
                    const pinMesh = scene.getMeshByName(`v_e_con.${String(i).padStart(3, '0')}`);
                    if (pinMesh) {
                        pinMesh.isPickable = true; // Make the mesh clickable
                    }
                }
                light.intensity = 0.2;
                const normalMeshes = ["v_e_con", ...Array.from({ length: 35 }, (_, i) => `v_e_con.${String(i + 1).padStart(3, '0')}`), "v_e_con_back"];
                // Iterate over each mesh in rootChildren
                rootChildren.forEach((mesh) => {
                    if (normalMeshes.includes(mesh.name)) {
                        // Keep these meshes normal (default visibility)
                        mesh.visibility = 1; // Normal visibility
                    }
                    else {
                        // Set visibility to 0.3 for other meshes
                        mesh.visibility = 0.1;
                    }
                });
                setTimeout(() => {
                    backButton.classList.remove("is-hidden");
                    // nextRowButton.classList.remove("is-hidden");
                    pinMenu.classList.remove("is-hidden");
                    // arrowPlane.setEnabled(true);
                    // updateRowColors(rowPositions, activeRowMaterial, normalPinMat);
                    Object.values(pinTextPlanes).forEach(plane => (plane.isVisible = true));
                    mainCamera.maxZ = 100000;
                    mainCamera.lowerAlphaLimit = 3.145;
                    mainCamera.upperAlphaLimit = 3.145;
                    if (isMobile()) {
                        mainCamera.lowerBetaLimit = 0.0;
                        mainCamera.upperBetaLimit = 0.0;
                    }
                    else {
                        mainCamera.lowerBetaLimit = 0.1;
                        mainCamera.upperBetaLimit = 0.1;
                    }
                    mainCamera.lowerRadiusLimit = 0.12;
                    mainCamera.upperRadiusLimit = 0.25;
                    // // mainCamera.wheelPrecision= 0.0628;
                    // mainCamera.pinchDeltaPercentage = 0.01
                    // mainCamera.wheelDeltaPercentage = 0.01
                    // mainCamera.speed = 0.0628
                    activateFirstRow();
                }, 1100);
                backButton.onclick = () => {
                    pinMenu.classList.add("is-hidden");
                    enableHighlights();
                    rootChildren.forEach((mesh) => {
                        mesh.visibility = 1;
                    });
                    for (let i = 1; i <= 35; i++) {
                        const pinMesh = scene.getMeshByName(`v_e_con.${String(i).padStart(3, '0')}`);
                        if (pinMesh) {
                            pinMesh.isPickable = false; // Make the mesh clickable
                        }
                    }
                    Object.values(pinTextPlanes).forEach(plane => (plane.isVisible = false));
                    // resetAllRowColors(rowPositions, normalPinMat);
                    // arrowPlane.setEnabled(false);
                    // updateArrowPosition(arrowPlane, new Vector3(-0.0245, 0.08, -0.03))
                    // currentRowIndex = 0;
                    setVisible(true);
                    // mainCamera.minZ = 0.01;
                    mainCamera.maxZ = 100000;
                    mainCamera.lowerBetaLimit = 0.1;
                    mainCamera.upperBetaLimit = 1.6;
                    mainCamera.lowerAlphaLimit = null;
                    mainCamera.upperAlphaLimit = null;
                    mainCamera.upperRadiusLimit = 1;
                    // mainCamera.wheelPrecision= 0.0628;
                    mainCamera.pinchDeltaPercentage = 0.003;
                    mainCamera.wheelDeltaPercentage = 0.01;
                    mainCamera.speed = 0.0628;
                    unHighlightPinBig();
                    changeCamera(mainCamera, scene, zeroPoint, 100, null);
                    installationBTN.classList.remove("is-hidden");
                    // actionButton.classList.remove("is-hidden");
                    backButton.classList.add("is-hidden");
                    pinMenu.classList.add("is-hidden");
                    // nextRowButton.classList.add("is-hidden");
                    light.intensity = .5;
                    rowsPlanes.forEach((rowPlanes) => {
                        rowPlanes.forEach(plane => plane.setEnabled(false)); // Hide all planes
                    });
                    pinData.forEach(pin => {
                        const pinMesh = scene.getMeshByName(`v_e_con.${String(pin.pin).padStart(3, '0')}`);
                        if (pinMesh) {
                            pinMesh.material = normalMaterialBig;
                        }
                    });
                    backButton.onclick = null;
                };
            }
            scene.getMeshByName("v_e_con").actionManager = new ActionManager(scene);
            scene.getMeshByName("v_e_con").actionManager.registerAction(new ExecuteCodeAction(ActionManager.OnPickTrigger, () => {
                goToBigPinMode();
            }));
            vehicleBtn.onclick = () => {
                goToBigPinMode();
            };
            scene.getMeshByName("v_e_con_back").actionManager = new ActionManager(scene);
            scene.getMeshByName("v_e_con_back").actionManager.registerAction(new ExecuteCodeAction(ActionManager.OnPickTrigger, () => {
                goToBigPinMode();
            }));
            const pinData = [
                { "pin": 1, "row": 1, "conn": "A", "id": "Vin+", "function": "Main power suply: 9-30V +" },
                { "pin": 2, "row": 1, "conn": "A", "id": "STO1", "function": "STO1 digital input" },
                { "pin": 3, "row": 1, "conn": "A", "id": "STO_COM", "function": "STO1/2 digital input " },
                { "pin": 4, "row": 1, "conn": "A", "id": "STO2", "function": "STO2 digital input" },
                { "pin": 5, "row": 1, "conn": "A", "id": "TEMP MOT 1 +", "function": "Motor temperature axis 1 +" },
                { "pin": 6, "row": 1, "conn": "A", "id": "SBC1", "function": "SBC1 digital input " },
                { "pin": 7, "row": 1, "conn": "A", "id": "SBC_COM", "function": "SBC1/2 digital input " },
                { "pin": 8, "row": 1, "conn": "A", "id": "SBC2", "function": "SBC1 digital input " },
                { "pin": 9, "row": 1, "conn": "A", "id": "TEMP MOT 2 +", "function": "Motor temperature axis 2 +" },
                { "pin": 10, "row": 1, "conn": "A", "id": "SLS1", "function": "SLS1 digital input " },
                { "pin": 11, "row": 1, "conn": "A", "id": "SLS_COM", "function": "SLS1/2 digital input" },
                { "pin": 12, "row": 1, "conn": "A", "id": "SLS2", "function": "SLS2 digital input " },
                { "pin": 13, "row": 2, "conn": "A", "id": "Vin-", "function": "MAIN POWER SUPPLY: GND" },
                { "pin": 14, "row": 2, "conn": "A", "id": "ENCODER1 PIN1", "function": "ENCODER 1: + 5V" },
                { "pin": 15, "row": 2, "conn": "A", "id": "ENCODER1 PIN2", "function": "ENCODER 1: GND" },
                { "pin": 16, "row": 2, "conn": "A", "id": "TEMP MOT 1 -", "function": "Motor temperature axis 1 GND" },
                { "pin": 17, "row": 2, "conn": "A", "id": "GND", "function": "GND" },
                { "pin": 18, "row": 2, "conn": "A", "id": "MODBUS +", "function": "Communication Modbus +" },
                { "pin": 19, "row": 2, "conn": "A", "id": "MODBUS -", "function": "Communication Modbus -" },
                { "pin": 20, "row": 2, "conn": "A", "id": "TEMP MOT 2 -", "function": "Motor temperature axis 2: GND" },
                { "pin": 21, "row": 2, "conn": "A", "id": "CAN H", "function": "Communication Can High" },
                { "pin": 22, "row": 2, "conn": "A", "id": "CAN L", "function": "Communication Can Low" },
                { "pin": 23, "row": 2, "conn": "A", "id": "BRAKE 2 -", "function": "Power supply brake axis 2: GND" },
                { "pin": 24, "row": 3, "conn": "A", "id": "ENCODER1 PIN3", "function": "ENCODER 1: SIN +" },
                { "pin": 25, "row": 3, "conn": "A", "id": "ENCODER1 PIN4", "function": "ENCODER 1: SIN -" },
                { "pin": 26, "row": 3, "conn": "A", "id": "ENCODER1 PIN5", "function": "ENCODER 1: COS +" },
                { "pin": 27, "row": 3, "conn": "A", "id": "ENCODER1 PIN6", "function": "ENCODER 1: COS -" },
                { "pin": 28, "row": 3, "conn": "A", "id": "ENCODER2 PIN1", "function": "ENCODER 2: + 5V" },
                { "pin": 29, "row": 3, "conn": "A", "id": "ENCODER2 PIN2", "function": "ENCODER 2: GND" },
                { "pin": 30, "row": 3, "conn": "A", "id": "ENCODER2 PIN3", "function": "ENCODER 2: SIN +" },
                { "pin": 31, "row": 3, "conn": "A", "id": "ENCODER2 PIN4", "function": "ENCODER 2: SIN -" },
                { "pin": 32, "row": 3, "conn": "A", "id": "ENCODER2 PIN5", "function": "ENCODER 2: COS +" },
                { "pin": 33, "row": 3, "conn": "A", "id": "ENCODER2 PIN6", "function": "ENCODER 2: COS -" },
                { "pin": 34, "row": 3, "conn": "A", "id": "BRAKE 1 -", "function": "Power supply brake axis 1: GND" },
                { "pin": 35, "row": 3, "conn": "A", "id": "BRAKE 1/2 +", "function": "BRAKE POWER SUPPLY axis 1/2" }
            ];
            var pinDropdown;
            const pinMenu = document.getElementById("pinMenu");
            function populateRows() {
                [1, 2, 3].forEach(row => {
                    const rowContainer = document.getElementById(`row${row}`);
                    const rowPins = pinData.filter(pin => pin.row === row);
                    rowPins.forEach(pin => {
                        const pinSpan = document.createElement('span');
                        pinSpan.textContent = `PIN ${pin.pin}: ${pin.function}`;
                        pinSpan.classList.add('pinSpan');
                        pinSpan.setAttribute('data-pin', String(pin.pin)); // Add data-pin attribute
                        pinSpan.onclick = () => highlightPinBig(pin.pin - 1);
                        rowContainer.appendChild(pinSpan);
                    });
                    // Initially hide the row
                    rowContainer.style.display = 'none';
                });
            }
            document.querySelectorAll('.rowButton').forEach(button => {
                button.addEventListener('click', function () {
                    document.querySelectorAll('.rowButton').forEach(btn => btn.classList.remove('activeBtn'));
                    this.classList.add('activeBtn');
                    const selectedRow = Number(this.dataset.row);
                    // Reset all pins to normal material
                    pinData.forEach(pin => {
                        const pinMesh = scene.getMeshByName(`v_e_con.${String(pin.pin).padStart(3, '0')}`);
                        if (pinMesh) {
                            pinMesh.material = normalMaterialBig;
                        }
                    });
                    // Apply activeRowMaterial to pins in the selected row
                    pinData
                        .filter(pin => pin.row === selectedRow)
                        .forEach(pin => {
                        const pinMesh = scene.getMeshByName(`v_e_con.${String(pin.pin).padStart(3, '0')}`);
                        if (pinMesh) {
                            pinMesh.material = activeRowMaterial;
                        }
                    });
                    // Toggle visibility of rows
                    document.querySelectorAll('.pinList').forEach(el => {
                        const element = el;
                        element.style.display = element.id === `row${selectedRow}` ? (element.style.display === 'none' ? 'flex' : 'none') : 'none';
                    });
                });
            });
            // Initialize the UI
            populateRows();
            pinMenu.classList.add("is-hidden");
            let currentPinIndexBig = 0;
            let pinPlanesBig = [];
            const normalMaterialBig = scene.getMaterialByName("gold");
            const highlightMaterial2 = new StandardMaterial("highlightMaterial", scene);
            highlightMaterial2.emissiveColor = new Color3(0.2, 0.62, 0.8);
            function createPinTextPlanes(scene) {
                const pinGroups = [
                    { name: "v_e_con.001", text: "1", position: new Vector3(-0.0156, 0.051, 0.0274) },
                    { name: "v_e_con.012", text: "12", position: new Vector3(-0.0156, 0.051, -0.021) },
                    { name: "v_e_con.013", text: "13", position: new Vector3(-0.0195, 0.051, 0.0274) },
                    { name: "v_e_con.023", text: "23", position: new Vector3(-0.0195, 0.051, -0.021) },
                    { name: "v_e_con.024", text: "24", position: new Vector3(-0.0240, 0.051, 0.0274) },
                    { name: "v_e_con.035", text: "35", position: new Vector3(-0.024, 0.051, -0.021) }
                ];
                const pinTextPlanes = {}; // Object to store created planes
                pinGroups.forEach(({ name, text, position }) => {
                    const targetMesh = scene.getMeshByName(name);
                    if (!targetMesh) {
                        console.warn(`Mesh ${name} not found`);
                        return;
                    }
                    const plane = MeshBuilder.CreatePlane(`textPlane_${name}`, { width: 0.0125, height: 0.0065 }, scene);
                    plane.position = position;
                    plane.rotation = new Vector3(Math.PI / 2, -Math.PI / 2, Math.PI);
                    const dynamicTexture = new DynamicTexture(`dynamicTexture_${name}`, { width: 128, height: 54 }, scene);
                    dynamicTexture.drawText(text, null, null, "14px appfont", "#454545", "transparent", true, true);
                    const material = new StandardMaterial(`textMaterial_${name}`, scene);
                    material.diffuseTexture = dynamicTexture;
                    material.emissiveColor = Color3.White();
                    material.opacityTexture = dynamicTexture;
                    material.alpha = 1;
                    plane.material = material;
                    plane.isPickable = false;
                    pinTextPlanes[name] = plane; // Store reference
                });
                return pinTextPlanes; // Return the object for later use
            }
            const pinTextPlanes = createPinTextPlanes(scene);
            Object.values(pinTextPlanes).forEach(plane => (plane.isVisible = false));
            let highlightedPinIndexBIg = null; // Keeps track of the currently highlighted pin
            let activePinBIg;
            function highlightPinBig(index) {
                const pin = pinData[index];
                const selectedRow = pin.row; // Get the row of the clicked pin
                // **1. Update Active Row Button**
                document.querySelectorAll('.rowButton').forEach(btn => btn.classList.remove('activeBtn'));
                const activeRowButton = document.querySelector(`.rowButton[data-row="${selectedRow}"]`);
                if (activeRowButton) {
                    activeRowButton.classList.add('activeBtn');
                }
                // **2. Show the Correct Row List**
                document.querySelectorAll('.pinList').forEach(el => {
                    const element = el;
                    element.style.display = element.id === `row${selectedRow}` ? 'flex' : 'none';
                });
                // **3. Reset Pins Not in Selected Row**
                pinData.forEach(p => {
                    const pinMesh = scene.getMeshByName(`v_e_con.${String(p.pin).padStart(3, '0')}`);
                    if (pinMesh) {
                        pinMesh.material = p.row === selectedRow ? activeRowMaterial : normalMaterialBig;
                    }
                });
                // **4. Highlight the Selected Pin**
                activePinBIg = scene.getMeshByName(`v_e_con.${String(pin.pin).padStart(3, '0')}`);
                if (activePinBIg) {
                    activePinBIg.material = highlightMaterial2;
                    // Remove previous planes
                    pinPlanesBig.forEach(plane => plane.dispose());
                    pinPlanesBig = [];
                    highlightedPinIndexBIg = index;
                }
                // **5. Update Dropdown**
                if (pinDropdown) {
                    const pinSelect = pinDropdown;
                    const option = pinSelect.querySelector(`option[value="${pin.pin}"]`);
                    if (option) {
                        pinSelect.value = String(pin.pin);
                        option.textContent = `Pin ${pin.pin}: ${pin.function}`;
                    }
                }
                // **6. Highlight the Pin in the HTML List**
                document.querySelectorAll('.pinSpan').forEach(pinSpan => pinSpan.classList.remove('activeBtn'));
                const clickedPinSpan = document.querySelector(`span[data-pin="${pin.pin}"]`);
                if (clickedPinSpan) {
                    clickedPinSpan.classList.add('activeBtn');
                }
            }
            function unHighlightPinBig() {
                if (highlightedPinIndexBIg !== null) {
                    // Reset the previously highlighted pin to its normal material
                    const previouslyHighlightedPin = scene.getMeshByName(`v_e_con.${String(pinData[highlightedPinIndexBIg].pin).padStart(3, '0')}`);
                    if (previouslyHighlightedPin) {
                        previouslyHighlightedPin.material = normalMaterialBig;
                    }
                    // Reset the row material to the normal material (assuming rows are identified by pin's row value)
                    const pin = pinData[highlightedPinIndexBIg];
                    const rowPins = pinData.filter(p => p.row === pin.row);
                    rowPins.forEach(rowPin => {
                        const rowPinMesh = scene.getMeshByName(`v_e_con.${String(rowPin.pin).padStart(3, '0')}`);
                        if (rowPinMesh) {
                            rowPinMesh.material = normalMaterialBig; // Reset the row pins to the normal material
                        }
                    });
                    // Remove the text planes
                    pinPlanesBig.forEach(plane => plane.dispose());
                    pinPlanesBig = [];
                    // highlightedPinIndexBIg = null; // Reset the highlighted pin index
                    // activePinBIg = null;
                }
            }
            pinData.forEach((pin, index) => {
                const mesh = scene.getMeshByName(`v_e_con.${String(pin.pin).padStart(3, '0')}`);
                if (mesh) {
                    mesh.isPickable = true;
                    if (!mesh.actionManager) {
                        mesh.actionManager = new ActionManager(scene);
                    }
                    mesh.actionManager.registerAction(new ExecuteCodeAction(ActionManager.OnPickTrigger, () => {
                        highlightPinBig(index);
                    }));
                }
            });
            const pinData2 = [
                { pin: 1, name: "espansion__con.001", function: "Digital input 1" },
                { pin: 2, name: "espansion__con.002", function: "Digital input 2" },
                { pin: 3, name: "espansion__con.003", function: "Digital input 3" },
                { pin: 4, name: "espansion__con.004", function: "Digital input 4" },
                { pin: 5, name: "espansion__con.005", function: "Digital input 5" },
                { pin: 6, name: "espansion__con.006", function: "Digital input 6" },
                { pin: 7, name: "espansion__con.007", function: "Digital input COM" },
                { pin: 8, name: "espansion__con.008", function: "Analog input +" },
                { pin: 9, name: "espansion__con.009", function: "Analog input -" },
                { pin: 10, name: "espansion__con.010", function: "Digital output 1" },
                { pin: 11, name: "espansion__con.011", function: "Digital output 2" },
                { pin: 12, name: "espansion__con.012", function: "GND" },
            ];
            // Track current selection
            let highlightedPinIndex = null;
            let activePin = null;
            // Materials
            const normalMaterialPin = scene.getMaterialByName("gold");
            const highlightMaterial = new StandardMaterial("highlightMaterial", scene);
            highlightMaterial.emissiveColor = new Color3(0.2, 0.62, 0.8);
            // Reference to the pin list container
            const pinListSmall = document.getElementById("pinListSmall");
            const menuContainerSmall = document.getElementById("menuContainerSmall");
            // Function to populate the pin list
            function populatePinList() {
                pinListSmall.innerHTML = ""; // Clear existing spans before populating
                pinData2.forEach((pin, index) => {
                    const pinSpan = document.createElement("span");
                    pinSpan.textContent = `PIN ${pin.pin}: ${pin.function}`;
                    pinSpan.classList.add("pinSpan2");
                    pinSpan.dataset.index = String(index); // Store index for click event
                    // Click event to highlight the pin
                    pinSpan.addEventListener("click", () => highlightPin(index));
                    pinListSmall.appendChild(pinSpan);
                });
            }
            // Highlight a specific pin
            function highlightPin(index) {
                if (highlightedPinIndex === index)
                    return; // Avoid redundant updates
                unHighlightPin(); // First, remove highlight from any active pin
                activePin = scene.getMeshByName(pinData2[index].name);
                if (activePin) {
                    activePin.material = highlightMaterial;
                    highlightedPinIndex = index;
                    // Update active class in the UI
                    document.querySelectorAll(".pinSpan2").forEach(span => span.classList.remove("active"));
                    document.querySelector(`.pinSpan2[data-index="${index}"]`)?.classList.add("active");
                }
            }
            // Unhighlight all pins
            function unHighlightPin() {
                if (highlightedPinIndex !== null) {
                    const previousPin = scene.getMeshByName(pinData2[highlightedPinIndex].name);
                    if (previousPin) {
                        previousPin.material = normalMaterialPin;
                    }
                }
                highlightedPinIndex = null;
                activePin = null;
                // Remove active class from spans
                document.querySelectorAll(".pinSpan2").forEach(span => span.classList.remove("active"));
            }
            // Add click events to pin meshes
            pinData2.forEach((pin, index) => {
                const mesh = scene.getMeshByName(pin.name);
                if (mesh) {
                    mesh.isPickable = true;
                    mesh.actionManager = new ActionManager(scene);
                    mesh.actionManager.registerAction(new ExecuteCodeAction(ActionManager.OnPickTrigger, () => {
                        highlightPin(index);
                    }));
                }
            });
            // Populate the pin list on load
            populatePinList();
            // Store all the planes for each row in an array
            let rowsPlanes = [];
            function createTextPlaneBig(scene, text, position, rotation) {
                const plane = MeshBuilder.CreatePlane("dimensionsPLane", { width: 0.5, height: 0.32 }, scene); // Smaller plane size
                plane.position = position;
                plane.rotation = rotation; // 90 degrees in radians
                // Dynamic texture with higher resolution for sharper text
                const dynamicTexture = new DynamicTexture("dynamicTexture", { width: 1024, height: 512 }, scene);
                const ctx = dynamicTexture.getContext();
                // Define font size and font
                const fontSize = 20;
                const font = `${fontSize}px sans-serif`;
                // Split the text into multiple lines manually
                const lines = text.split("\n").map(line => line.trim()); // Split by newline and trim any extra spaces
                const lineHeight = 1.5 * fontSize; // Define the height between lines
                let yPosition = 15; // Starting Y position
                // Draw each line of text
                lines.forEach((line, index) => {
                    ctx.font = font;
                    dynamicTexture.drawText(line, 4, yPosition, font, "black", "transparent");
                    yPosition += lineHeight; // Adjust Y for the next line
                });
                // Apply the texture to the plane
                const material = new StandardMaterial("textMaterial", scene);
                material.diffuseTexture = dynamicTexture;
                material.emissiveColor = Color3.Black();
                material.opacityTexture = dynamicTexture;
                plane.material = material;
                plane.isPickable = false; // Ensures the plane is not clickable
                return plane;
            }
            function toggleMaterial(mesh, activeMaterial, normalMaterial, interval) {
                let isActive = false; // Tracks the current state
                const toggleInterval = setInterval(() => {
                    mesh.material = isActive ? normalMaterial : activeMaterial; // Toggle material
                    isActive = !isActive; // Switch the state
                }, interval);
                // Return a function to stop the blinking
                return () => clearInterval(toggleInterval);
            }
            let rotationNormal = new Vector3(Math.PI / 2, 0, Math.PI / 2);
            let rotationSide = new Vector3(Math.PI / 2, Math.PI / 2, Math.PI / 2);
            let rotationSide2 = new Vector3(Math.PI / 2, -Math.PI / 2, Math.PI / 2);
            const screwsPlane = createTextPlaneBig(scene, "TCEI M4", new Vector3(0.103, .02, 0.316), rotationNormal);
            console.log(screwsPlane);
            screwsPlane.isVisible = false;
            const dimensionsPlane1 = createTextPlaneBig(scene, "117,5 mm", new Vector3(0.055, .005, 0.23), rotationNormal);
            const dimensionsPlane2 = createTextPlaneBig(scene, "109,5 mm", new Vector3(0.24, .005, 0.23), rotationNormal);
            const dimensionsPlane3 = createTextPlaneBig(scene, "134 mm", new Vector3(0.23, .005, -0.061), rotationSide);
            const dimensionsPlane4 = createTextPlaneBig(scene, "69,8 mm", new Vector3(-0.194, .005, 0.073), rotationSide2);
            const dimensionsPlanesArray = [dimensionsPlane1, dimensionsPlane2, dimensionsPlane3, dimensionsPlane4];
            for (const mesh of dimensionsPlanesArray) {
                mesh.isVisible = false;
            }
            scene.getTransformNodeByName("dimensions").position.y = 0.004;
            function showHideDimensions(node, planes) {
                scene.getTransformNodeByName("dimensions").setEnabled(node);
                scene.getMeshByName("Plane_6").setEnabled(planes);
                scene.getMeshByName("Plane_8").setEnabled(planes);
            }
            showHideDimensions(false, false);
            // Ensure `stopBlinking` is properly initialized
            let stopBlinking = () => { };
            // Define LED color cycles
            const ledColors = {
                1: ["orange", "green", "red", "off"],
                2: ["green", "red", "off"],
                3: ["green", "red"],
                4: ["green", "red"] // CAN
            };
            // Track LED states
            const ledState = {
                1: 0,
                2: 0,
                3: 0,
                4: 0
            };
            function setLED(pos, color) {
                console.log(`LED ${pos} changed to ${color}`);
                const led = scene.getMeshByName(`leds.00${pos}`);
                if (!led)
                    return;
                // Default off material
                const normalLEDMat = scene.getMaterialByName("led");
                let activeMaterial = normalLEDMat;
                // Reuse existing materials instead of creating new ones
                const materials = {
                    orange: scene.getMaterialByName("orangeLEDMaterial") || new StandardMaterial("orangeLEDMaterial", scene),
                    green: scene.getMaterialByName("greenLEDMaterial") || new StandardMaterial("greenLEDMaterial", scene),
                    red: scene.getMaterialByName("redLEDMaterial") || new StandardMaterial("redLEDMaterial", scene)
                };
                if (color in materials) {
                    activeMaterial = materials[color];
                    switch (color) {
                        case "orange":
                            activeMaterial.diffuseColor = new Color3(1, 0.5, 0);
                            activeMaterial.emissiveColor = new Color3(1, 0.5, 0);
                            break;
                        case "green":
                            activeMaterial.diffuseColor = new Color3(0, 1, 0);
                            activeMaterial.emissiveColor = new Color3(0, 1, 0);
                            break;
                        case "red":
                            activeMaterial.diffuseColor = new Color3(1, 0, 0);
                            activeMaterial.emissiveColor = new Color3(1, 0, 0);
                            break;
                    }
                }
                // Apply the material
                led.material = activeMaterial;
                // Handle blinking effect for LED 4 when green
                if (pos === 4 && color === "green") {
                    stopBlinking = toggleMaterial(led, activeMaterial, normalLEDMat, 500);
                }
                else {
                    stopBlinking();
                }
                // Update radio button selection
                document.querySelectorAll(`input[name='led-${pos}']`).forEach((radio) => {
                    radio.checked = radio.value === color;
                });
            }
            /**
             * Cycles LED colors on mesh click.
             */
            function cycleLED(ledIndex) {
                if (!ledColors[ledIndex])
                    return;
                // Get the next color in the cycle
                ledState[ledIndex] = (ledState[ledIndex] + 1) % ledColors[ledIndex].length;
                const newColor = ledColors[ledIndex][ledState[ledIndex]];
                console.log(`Cycling LED ${ledIndex} to ${newColor}`);
                // Update LED
                setLED(ledIndex, newColor);
                // Update the corresponding radio button
                const radioButton = document.querySelector(`input[name='led-${ledIndex}'][value='${newColor}']`);
                if (radioButton) {
                    radioButton.checked = true;
                    // Simulate a "change" event to trigger showTooltip
                    radioButton.dispatchEvent(new Event("change", { bubbles: true }));
                }
            }
            /**
             * Event listener for radio buttons.
             */
            document.querySelectorAll("input[type='radio']").forEach((radio) => {
                radio.addEventListener("change", (event) => {
                    const target = event.target;
                    if (!target.name || !target.value) {
                        console.error("Invalid radio button:", target);
                        return;
                    }
                    const parts = target.name.split("-");
                    if (parts.length !== 2) {
                        console.error("Unexpected radio button format:", target.name);
                        return;
                    }
                    const ledIndex = parseInt(parts[1]);
                    if (isNaN(ledIndex)) {
                        console.error("Invalid LED index:", ledIndex);
                        return;
                    }
                    console.log(`Radio button changed LED ${ledIndex} to ${target.value}`);
                    setLED(ledIndex, target.value);
                    showTooltip(target);
                });
            });
            /**
             * Attach click event listeners to LED meshes.
             */
            const ledClickColor = () => {
                for (let i = 1; i <= 4; i++) {
                    const ledMesh = scene.getMeshByName(`leds.00${i}`);
                    if (ledMesh) {
                        ledMesh.actionManager = new ActionManager(scene);
                        ledMesh.actionManager.registerAction(new ExecuteCodeAction(ActionManager.OnPickTrigger, () => {
                            if (ledMode !== "cycle")
                                return; // Only run if in "cycle" mode
                            cycleLED(i);
                        }));
                    }
                }
            };
            /**
          * Shows a tooltip next to the selected radio button.
          */
            function showTooltip(target) {
                const tooltip = document.getElementById("tooltip");
                if (!tooltip)
                    return;
                const tooltipText = target.getAttribute("data-tooltip");
                if (tooltipText) {
                    tooltip.textContent = tooltipText;
                    tooltip.style.visibility = "visible";
                    // Position tooltip near the radio button
                    const rect = target.getBoundingClientRect();
                    tooltip.style.top = `${rect.top + window.scrollY}px`;
                    tooltip.style.left = `${rect.left + window.scrollX + 20}px`;
                }
            }
            // Hide tooltip if another area is clicked or radio buttons are reset
            document.body.addEventListener("click", (event) => {
                const tooltip = document.getElementById("tooltip");
                if (tooltip) {
                    tooltip.style.visibility = "hidden"; // Hide tooltip when clicking anywhere else
                }
            });
            // Create highlight materials
            // const highlightMateriall = new StandardMaterial("highlight", scene);
            // highlightMateriall.emissiveColor = new Color3(1, 1, 0); // Yellow glow
            // const normalMateriall = new StandardMaterial("normal", scene);
            // normalMateriall.diffuseColor = new Color3(1, 1, 1); // Default white
            // Define mesh groups
            const groups = {
                1: ["connections.003", "connections.004", "connections.005"],
                2: ["connections.001", "connections.002"],
                3: ["espansion__con", "espansion__con.001", "espansion__con.002", "espansion__con.003", "espansion__con.004",
                    "espansion__con.005", "espansion__con.006", "espansion__con.007", "espansion__con.008", "espansion__con.009",
                    "espansion__con.010", "espansion__con.011", "espansion__con.012"],
                4: ["leds.001", "leds.002", "leds.003", "leds.004"],
                5: ["v_e_con", "v_e_con_back"]
            };
            // Function to normalize alpha to the range [0, 2π]
            function normalizeAngle(angle) {
                return angle - Math.floor(angle / (2 * Math.PI)) * 2 * Math.PI;
            }
            // Function to calculate the shortest rotation path
            function calculateShortestPathAlpha(currentAlpha, targetAlpha) {
                let deltaAlpha = targetAlpha - currentAlpha;
                if (Math.abs(deltaAlpha) > Math.PI) {
                    if (deltaAlpha > 0) {
                        deltaAlpha -= 2 * Math.PI;
                    }
                    else {
                        deltaAlpha += 2 * Math.PI;
                    }
                }
                return currentAlpha + deltaAlpha;
            }
            const normalMaterial = scene.getMaterialByName("chrome_tin_plated");
            const blackMaterial = scene.getMaterialByName("black");
            const ledMaterial = scene.getMaterialByName("led");
            let highlightEnabled = true; // Flag to control updates
            // Function to update highlights based on custom alpha ranges
            function resetMaterials() {
                Object.values(groups).flat().forEach(meshName => {
                    const mesh = scene.getMeshByName(meshName);
                    if (mesh) {
                        mesh.material = normalMaterial;
                        mesh.isPickable = false;
                    }
                    scene.getMeshByName("v_e_con").material = blackMaterial;
                    scene.getMeshByName("v_e_con_back").material = blackMaterial;
                    ledOne.material = ledMaterial;
                    ledTwo.material = ledMaterial;
                    ledThree.material = ledMaterial;
                    ledFour.material = ledMaterial;
                });
            }
            const updateHighlights = () => {
                if (!highlightEnabled)
                    return; // Skip updates when disabled
                let alpha = normalizeAngle(mainCamera.alpha); // Normalize alpha
                let activeGroup = 0;
                if (alpha >= 1.5 && alpha < 2.3)
                    activeGroup = 4;
                else if (alpha >= 2.31 && alpha < 3.2)
                    activeGroup = 2;
                else if (alpha >= 3.21 && alpha < 4.4)
                    activeGroup = 5;
                else if (alpha >= 4.41 && alpha < 5.5)
                    activeGroup = 3;
                else if (alpha >= 5.51 && alpha < 6.9)
                    activeGroup = 1;
                // Reset all materials and set isPickable/isClickable to false
                Object.values(groups).flat().forEach(meshName => {
                    const mesh = scene.getMeshByName(meshName);
                    if (mesh) {
                        mesh.material = normalMaterial;
                        mesh.isPickable = false;
                    }
                    scene.getMeshByName("v_e_con").material = blackMaterial;
                    scene.getMeshByName("v_e_con_back").material = blackMaterial;
                    ledOne.material = ledMaterial;
                    ledTwo.material = ledMaterial;
                    ledThree.material = ledMaterial;
                    ledFour.material = ledMaterial;
                });
                // Highlight active group and set isPickable/isClickable to true
                groups[activeGroup]?.forEach(meshName => {
                    const mesh = scene.getMeshByName(meshName);
                    if (mesh) {
                        mesh.material = highlightMaterial;
                        mesh.isPickable = true;
                    }
                });
                // Handle HTML element activation
                const elements = [
                    aceBtn,
                    batteryBtn,
                    espansionBtn,
                    ledsBtn,
                    vehicleBtn
                ];
                elements.forEach((el, index) => {
                    if (el) {
                        if (index + 1 === activeGroup) {
                            el.classList.add("activated");
                        }
                        else {
                            el.classList.remove("activated");
                        }
                    }
                });
            };
            // Run function on every frame
            scene.onBeforeRenderObservable.add(updateHighlights);
            const enableHighlights = () => {
                highlightEnabled = true;
            };
            const disableHighlights = () => {
                highlightEnabled = false;
                resetMaterials();
            };
            window.addEventListener("resize", () => {
                const dpr = window.devicePixelRatio;
                console.log("Resize event - DPR:", dpr);
                // Sprawdzenie, czy devicePixelRatio się nie zmieniło
                if (dpr !== engine.getHardwareScalingLevel()) {
                    engine.setHardwareScalingLevel(1 / dpr);
                }
                engine.resize(true);
                // updateAnnotationPositions();
                console.log("Canvas resized:", engine.getRenderWidth(), engine.getRenderHeight());
            });
            setVisible(true);
            if (window.self !== window.top) {
                console.log("The page is loaded inside an iframe.");
            }
            else {
                console.log("The page is not loaded inside an iframe.");
            }
            function isMobile() {
                console.log(/Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent));
                return /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);
            }
            console.log("Window innerWidth: " + window.innerWidth);
            console.log("Window innerHeight: " + window.innerHeight);
            return scene;
        };
    }
    get createScene() {
        return this._createScene;
    }
    set createScene(value) {
        this._createScene = value;
    }
}
export default new AppModeController();
